<template>
  <InputText v-bind="$attrs" v-model="value" ref="input">
    <template v-if="label" #label>{{ label }}</template>
    <template #startAdornment
      ><i class="material-symbols-rounded text-[1.5rem]">search</i></template
    >
    <template #endAdornment>
      <i class="material-symbols-rounded material-spin text-[1.25rem]" v-if="loading">replay</i>
      <!-- @vue-expect-error FIXME: 'MouseEvent' not assignable to 'PointerEvent' -->
      <i
        v-else-if="hasValue && showClearFilter"
        class="material-symbols-rounded text-[1.25rem] cursor-pointer"
        @click="onClearClick($event)"
        >cancel</i
      >
      <!-- Workaround to avoid a clickable area issue -->
      <i v-else></i>
    </template>
    <!-- <template v-if="helperText" #helperText>{{ helperText }}</template> -->
  </InputText>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { InputText } from '../input-text';

defineOptions({
  name: 'InputTextSearch',
  inheritAttrs: false,
});

const emit = defineEmits(['change']);

const props = defineProps({
  label: String,
  helperText: String,
  loading: Boolean,
  showClearFilter: {
    type: Boolean,
    default: true,
  },
});

const value = defineModel<string>({ type: String });

const input = ref<typeof InputText>();

const hasValue = computed<boolean>(() => {
  return input?.value?.value ? true : false;
});

const onClearClick = (event: PointerEvent): void => {
  value.value = null;
  emit('change', { originalEvent: event, value: null });
};

defineExpose({ props });
</script>
